import React, { useCallback } from 'react';
import { ODD_CHANGE_TYPES } from '../../enums/betTypesEnum';

export function ExtraBetsOddSection({ currentSelection, isOddLose }) {
  const getOddText = useCallback(() => {
    if (!currentSelection) {
      return '';
    }
    if (currentSelection?.isWin) {
      return 'WIN';
    }
    if (currentSelection.odd <= 1 || isOddLose) {
      return 'LOSE';
    }
    return `x${currentSelection.odd}`;
  }, [currentSelection, isOddLose]);

  return (
    /* ADD class "state-win, state-lose, default " */
    <div
      className={`combinations-state-cont ${getOddText().length > 5 ? 'sm-num' : ''} ${
        // eslint-disable-next-line
        !currentSelection?.isWin && currentSelection && (currentSelection.odd <= 1 || isOddLose)
          ? 'state-lose'
          : currentSelection?.isWin
          ? ''
          : 'default'
      } ${currentSelection?.isWin ? 'state-win' : ''}`}
    >
      <div className='combinations-state-cont-inner'>
        <p className='combinations-state-cont-inner-text'>
          {getOddText()}
          {/* Win */}
        </p>
        {!currentSelection?.isWin &&
          !isOddLose &&
          currentSelection?.odd > 1 &&
          currentSelection?.oddChange !== ODD_CHANGE_TYPES.none && (
            <i
              className={`icon-play combinations-row-arrow ${
                currentSelection?.oddChange === ODD_CHANGE_TYPES.over ? 'state-green' : ''
              } ${currentSelection?.oddChange === ODD_CHANGE_TYPES.under ? 'state-lose' : ''}`}
            />
          )}
      </div>
      {/* <div className='combinations-state-cont-inner'> */}
      {/*  <p className='combinations-state-cont-inner-text'>x1000</p> */}
      {/*  /!* ADD class "state-green" *!/ */}
      {/* </div> */}
    </div>
    /* ADD class "active, disabled" */
  );
}
